var _circle, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "24.5 24.5 562.2 562.2",
    enableBackground: "new 24.5 24.5 562.2 562.2",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 305.8,
    cy: 305.7,
    r: 191.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M305.8,88.3c-83.1,0-155.4,46.8-192,115.5c5.4-4.1,10.6-4.6,11.6-4.4c2,0.3,12.5,6.1,6.1,26.2 C161.9,159.6,228.4,114,305.8,114c106,0,191.7,85.7,191.7,191.7s-85.7,191.7-191.7,191.7s-191.7-85.7-191.7-191.7 c0-8.1,0.5-16.1,1.5-23.9c-1.4-0.6-2.6-1.2-4-2l-21.3-3.4c-1.2,9.5-2,19.3-2,29.1C88.4,425.4,186,523,305.8,523 s217.4-97.6,217.4-217.4S425.6,88.3,305.8,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M100.7,233.8c-0.8,2.1-1.5,4.4-2.1,6.6c0.5-0.3,0.8-0.5,1.2-0.6C100.1,237.5,100.4,235.6,100.7,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M115.7,282c2.4-19.9,8-38.7,16.1-56.3c6.3-20-4.3-25.9-6.1-26.2c-1.1-0.2-6.3,0.3-11.6,4.4 c-5,9.6-9.5,19.6-13.2,29.8c-0.3,1.8-0.6,3.7-1.1,6c-0.5,0.3-0.8,0.5-1.2,0.6c-3.7,11.6-6.4,23.9-8.1,36.3l21.3,3.4 C113.1,280.6,114.3,281.4,115.7,282z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8558,
    y1: 478.1283,
    x2: 147.7416,
    y2: 416.4178,
    gradientTransform: "matrix(3.2211 0 0 3.2211 0 -1172.6971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#D8292F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8292F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M305.8,101.2c105.7,0,191.7,98.7,191.7,204.6c8.4-2.6,17.7-2.3,25.7,1.2v-1.2 C523.3,185.9,425.6,101.2,305.8,101.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8292F",
    d: "M484.4,234.3c9.9,25.4,14.1,58.8,12.7,58.3c-20.5-7.3-31.7-11-53.7-18.4c0,3.5,0,5.2,0,8.7 c21.3,18.1,31.5,27.7,51.3,47c-1.2,8.7-2.3,13.2-3.8,21.9c-2.9,21.9,7.8,26.5,9.3,26.5c1.7,0,14.8-3.2,18.4-24.2 c0.9-7.8,1.2-11.9,2-19.6c21.9-17.4,32.3-26.5,52.2-45.4c0-3.8,0-5.8,0-9.6c-18.8,6.4-28.5,9.6-47.6,15.6c-0.2,0-3.4,1.1-3.5,1.1"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spinner.d304d823470b794b354e03500b5e29bc.svg";